module.exports = {"preferred-locale":{"header":"Language","button":"Change language"}};